import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-staff-login',
  templateUrl: './staff-login.component.html',
  styleUrls: ['./staff-login.component.css']
})
export class StaffLoginComponent implements OnInit {

  IDPasswordList=[];
  StaffList=[];
  Submitted=false;
  Count1=0;
  PersonList=[];
  RoleList=[];
  MapList=[];
  UserTypeList=[];
  DesignationList=[];
  DepartmentList=[];
  EmployeeCategoryList=[];
  EmployeeTypeList=[];
  StaffResetList=[];

  constructor(private adminservice: AdminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    StaffLoginModel = {
      CurrentIndex: 0,
      PageSize: 0,
      Message: '',
      PrimaryDepartmentID: 0,
      DesignationID:0,
      EmployeeCategoryID:0,
      EmployeeTypeID: 0,
      UserLoginID: 0,
      UserTypeID: 0,
     
  }
  
  ValidityState() {
      return this.StaffLoginModel.UserTypeID == 0;
  }

  SendStaffLoginID() {
      this.IDPasswordList = [];     
      for (var i = 0; i < this.StaffList.length; i++) {
          if (this.StaffList[i].IsSelectAction == true && this.StaffList[i].UserID != null) {
              var item = {
                  UserID: this.StaffList[i].UserID,
                  Pasword: this.StaffList[i].Password,
                  Keys: this.StaffList[i].Keys,
                  Mobile: this.StaffList[i].Mobile,
                  Name: this.StaffList[i].Name,
              }
              this.IDPasswordList.push(item);
          }

      }
      this.spinnerService.show();
      this.adminservice.SendStaffLoginID(JSON.stringify(this.IDPasswordList)).subscribe((data: any) => {
        this.spinnerService.hide();
          if (data.webResponse.Status) {
              this.ClearSelection();
             
          }
          this.globalHelper.CheckActionStatus(data);
      });


  }
 
  GetStaffLoginID() {
      this.Submitted = true;
      if (!this.ValidityState()) {
        this.spinnerService.show();
         
          this.adminservice.GetStaffLoginID(JSON.stringify(this.StaffLoginModel)).subscribe((data: any) => {
              this.StaffList = data.StaffList;
              this.spinnerService.hide();
              this.globalHelper.CheckActionStatus(data);
          });
      }
  };

  ChangePersonType() {
      this.StaffList = [];     
      this.SelectModel.IsSelect = false;
     
      for (var i = 0; i < this.StaffList.length; i++) {
          this.StaffList[i].Active = false;

      }
  }

  SelectModel = {
    IsSelect:false,
    IsAction:false,
  }

  SelectAll() {
      if (this.SelectModel.IsSelect) {
          for (var i = 0; i < this.StaffList.length; i++) {
              this.StaffList[i].Active = true;
          }
      }
      if (this.SelectModel.IsSelect == false) {
          for (var i = 0; i < this.StaffList.length; i++) {
              this.StaffList[i].Active = false;
          }
      }
  }
  ChangeSelect(item) {
      this.Count1 = 0;
     
          for (var i = 0; i < this.StaffList.length; i++) {
              if (this.StaffList[i].Active) {
                  this.Count1 = this.Count1 + 1

              }
          }
      

      if (this.Count1 == this.StaffList.length) {
          this.SelectModel.IsSelect = true;

      }
      else {
          this.SelectModel.IsSelect = false;
      }

  }


  SaveStaffLoginID() {
      this.Submitted = true;         
      if (!this.ValidityState()) {
         this.spinnerService.show();
          for (var i = 0; i < this.StaffList.length; i++) {
              if (this.StaffList[i].Active == true && this.StaffList[i].UserID == null) {
                  var Password = 'faculty';
                  var item = {
                      StaffIdentity: this.StaffList[i].StaffIdentity,
                      StaffID: this.StaffList[i].StaffID,
                      Password: Password
                  }
                  this.PersonList.push(item);
              }

          }
         

          this.adminservice.SaveStaffLoginID(JSON.stringify(this.StaffLoginModel), JSON.stringify(this.PersonList)).subscribe((data: any) => {
              if (data.webResponse.Status) {
                  this.PersonList.splice(0);
                  this.ClearSelection();
                  this.GetStaffLoginID();
              }
              this.globalHelper.CheckActionStatus(data);             
          });
      }

  }

  StaffAccessModel={
    UserLoginID:0,
    IsAllowPaymentDateChange:false   
  }

  SetAccessRight(obj) {
    this.StaffAccessModel.UserLoginID = obj.UserLoginID;
    this.adminservice.GetStaffAccessRight(JSON.stringify(this.StaffAccessModel)).subscribe((data: any) => {
        this.StaffAccessModel= data.StaffAccessModel;
    });
}

SaveStaffAccessRight() {
    this.spinnerService.show();    
     this.adminservice.SaveStaffAccessRight(JSON.stringify(this.StaffAccessModel)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
         
     });

 }


  RoleModel = {
      StaffID: 0,
      UserLoginID:0,
      RoleSelect:false
     
  }

  SetRole(obj) {
      this.RoleModel.StaffID = obj.StaffID;
      this.RoleModel.UserLoginID = obj.UserLoginID;
      this.adminservice.GetStaffRole(JSON.stringify(this.RoleModel)).subscribe((data: any) => {
          this.RoleList = data.RoleList;
      });
  }


  SaveRoleMap() {
     this.MapList=[];
      for (var i = 0; i < this.RoleList.length; i++) {
         
              var item = {
                  RoleID: this.RoleList[i].RoleID,
                  IsActive: this.RoleList[i].IsActive
              }
              this.MapList.push(item);
         

      }
      this.spinnerService.show();
     
      this.adminservice.SaveRoleMap(JSON.stringify(this.RoleModel), JSON.stringify(this.MapList)).subscribe((data: any) => {
         this.spinnerService.hide();
          if (data.webResponse.Status) {
              this.MapList.splice(0);
              this.GetStaffLoginID();             
          }
          this.globalHelper.CheckActionStatus(data);
          
      });

  }


  BindUserType() {
      this.lookupservice.GetLookupsList('StaffUserType', '').subscribe((data: any) => {
          this.UserTypeList = data.LookupItems;
      });
  };

  GetDesignation() {
      this,this.lookupservice.GetLookupsList('Designation', '').subscribe((data: any) => {
          this.DesignationList = data.LookupItems;
      });
  };

  GetDepartment() {
      this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
          this.DepartmentList = data.LookupItems;
      });
  };

  GetEmployeeCategory() {
      this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
          this.EmployeeCategoryList = data.LookupItems;
      });
  };

  GetEmployeeType() {
      this.lookupservice.GetLookupsList('EmployeeType', '').subscribe((data: any) => {
          this.EmployeeTypeList = data.LookupItems;
      });
  };

  // Password Reset

  ClearSelection() {
      this.SelectModel.IsSelect = false;
      this.SelectModel.IsAction = false;
  }

  SelectAllAction() {
      if (this.SelectModel.IsAction) {
          for (var i = 0; i < this.StaffList.length; i++) {
              this.StaffList[i].IsSelectAction = true;
          }
      }
      if (this.SelectModel.IsAction == false) {
          for (var i = 0; i < this.StaffList.length; i++) {
              this.StaffList[i].IsSelectAction = false;

          }
      }

  }

  ChangeActionSelect = function (item) {
      this.Count = 0;
      for (var i = 0; i < this.StaffList.length; i++) {
          if (this.StaffList[i].IsSelectAction) {
              this.Count = this.Count + 1

          }
      }


      if (this.Count == this.StaffList.length) {
          this.SelectModel.IsAction = true;
      }

      else {
          this.SelectModel.IsAction = false;
      }

  }
  ResetStaffLoginID() {
      this.StaffResetList = [];
     this.spinnerService.show();
      for (var i = 0; i < this.StaffList.length; i++) {
          if (this.StaffList[i].IsSelectAction == true && this.StaffList[i].UserID != null) {
              var item = {
                  UserID: this.StaffList[i].UserID,                 
              }
              this.StaffResetList.push(item);
          }

      }
      this.adminservice.ResetStaffLoginID(JSON.stringify(this.StaffResetList)).subscribe((data: any) => {
         this.spinnerService.hide();
          if (data.webResponse.Status) {
              this.ClearSelection();
              this.GetStaffLoginID();
          }
         this.globalHelper.CheckActionStatus(data);
      });


  }

  // Mark Active/InActive

  MarkActiveStaffLoginID() {
      this.StaffResetList = [];
      this.spinnerService.show();
      for (var i = 0; i < this.StaffList.length; i++) {
          if (this.StaffList[i].IsSelectAction == true && this.StaffList[i].UserID != null) {
              var item = {
                  UserID: this.StaffList[i].UserID,
                  IsActive: this.StaffList[i].IsActive == false ? true : false
              }
              this.StaffResetList.push(item);
          }

      }
      this.adminservice.MarkActiveStaffLoginID(JSON.stringify(this.StaffResetList)).subscribe((data: any) => {
          this.spinnerService.hide();
          if (data.webResponse.Status) {
              this.ClearSelection();
              this.GetStaffLoginID();
          }
          this.globalHelper.CheckActionStatus(data);
      });


  }



  ngOnInit() {
    this.BindUserType();
    this.GetEmployeeType();
    this.GetDesignation();
    this.GetDepartment();
    this.GetEmployeeCategory();
  }

}
